(() => {
  const MOBILE_QUERY = '(max-width: 1023px)';
  const DRAWER_CLOSE_DELAY = 320;

  const getSearchParts = (toggle) => {
    if (!toggle) return {};
    const containerId = toggle.getAttribute('aria-controls');
    const container = containerId ? document.getElementById(containerId) : null;
    const input = container ? container.querySelector('input[type="search"][name="q"]') : null;
    return { container, input };
  };

  const closeSearch = (toggle, container, restoreFocus = false) => {
    if (!toggle || !container) return;
    container.classList.remove('is-mobile-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle.focus();
  };

  const activateSearchInput = (input) => {
    if (!input) return;

    requestAnimationFrame(() => {
      try {
        input.focus({ preventScroll: true });
      } catch (_) {
        input.focus();
      }

      // The input is intentionally a normal Shopify/theme search field.
      // Search apps may listen to its native focus/click events; if no app is
      // installed, the visible field and its /search form continue to work.
      input.click();
    });
  };

  const openSearch = (toggle, container, input) => {
    if (!toggle || !container || !input) return;

    container.classList.add('is-mobile-open');
    toggle.setAttribute('aria-expanded', 'true');
    activateSearchInput(input);
  };

  const bindSearchToggle = (toggle) => {
    if (!toggle || toggle.dataset.c24hSearchBound === 'true') return;

    const { container, input } = getSearchParts(toggle);
    if (!container || !input) return;

    toggle.dataset.c24hSearchBound = 'true';

    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      if (container.classList.contains('is-mobile-open')) {
        closeSearch(toggle, container, false);
      } else {
        openSearch(toggle, container, input);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && container.classList.contains('is-mobile-open')) {
        closeSearch(toggle, container, true);
      }
    });

    document.addEventListener('click', (event) => {
      if (!container.classList.contains('is-mobile-open')) return;
      if (container.contains(event.target) || toggle.contains(event.target)) return;
      closeSearch(toggle, container, false);
    });

    const media = window.matchMedia(MOBILE_QUERY);
    const syncViewport = () => {
      if (!media.matches) closeSearch(toggle, container, false);
    };

    if (media.addEventListener) {
      media.addEventListener('change', syncViewport);
    } else if (media.addListener) {
      media.addListener(syncViewport);
    }
  };

  const openHeaderSearchFromDrawer = (link) => {
    const toggle = document.querySelector('[data-c24h-search-toggle]');
    const { container, input } = getSearchParts(toggle);

    // Progressive enhancement: if our custom mobile header is not present,
    // don't intercept the link. Its href="/search" remains the native fallback.
    if (!toggle || !container || !input) return false;

    const drawer = link.closest('[data-drawer]') || document.getElementById('nav-drawer');
    const closeButton = drawer ? drawer.querySelector('.drawer__close-button[data-drawer-toggle]') : null;

    if (closeButton) {
      // Let Palo Alto close its own drawer. Do not manually remove classes,
      // attributes or scroll locks owned by the theme.
      closeButton.click();
      window.setTimeout(() => openSearch(toggle, container, input), DRAWER_CLOSE_DELAY);
    } else {
      openSearch(toggle, container, input);
    }

    return true;
  };

  const bindDrawerSearch = () => {
    if (document.documentElement.dataset.c24hDrawerSearchBound === 'true') return;
    document.documentElement.dataset.c24hDrawerSearchBound = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-c24h-drawer-search]');
      if (!link) return;

      if (openHeaderSearchFromDrawer(link)) {
        event.preventDefault();
      }
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-c24h-search-toggle]').forEach(bindSearchToggle);
    bindDrawerSearch();
  };

  const boot = () => {
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
